export default function formatError(error) {
    var data = {};
    if (error.response) {
      data = error.response;
    } else {
      data.message = ["Failed", "Something went wrong. Please try again."];
    }
    return data;
  }
  


// WEBPACK FOOTER //
// ./src/formatErrors.js